import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { BlankSteps } from "./BlankSteps";
import { MediaObject } from "../mediaobject";
import { useConfig } from "../_util/config-context";
import { H4 } from "../heading";
import { warn } from "../_util/warn";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
export var Blank = forwardRefWithStatics(function Blank(_a, ref) {
    var theme = _a.theme, image = _a.image, title = _a.title, description = _a.description, operation = _a.operation, extra = _a.extra, children = _a.children, bottom = _a.bottom, className = _a.className, props = __rest(_a, ["theme", "image", "title", "description", "operation", "extra", "children", "bottom", "className"]);
    var classPrefix = useConfig().classPrefix;
    if (!theme || image) {
        if (bottom && !Array.isArray(bottom)) {
            // eslint-disable-next-line no-param-reassign
            bottom = [bottom];
        }
        return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-card", classPrefix + "-blank-page-v2", className) }, props),
            React.createElement("div", { className: classPrefix + "-blank-page-v2__main" },
                React.createElement("div", { className: classPrefix + "-blank-page-v2__content" },
                    image.logo && (React.createElement("div", { className: classPrefix + "-blank-page-v2__logo" },
                        React.createElement("img", { src: image.logo, alt: "logo" }))),
                    React.createElement("div", { className: classPrefix + "-blank-page-v2__title" },
                        React.createElement("h2", { className: classPrefix + "-blank-page-v2__title-zh" }, title)),
                    children,
                    React.createElement("div", { className: classPrefix + "-blank-page-v2__opreate" },
                        operation,
                        extra && React.createElement("div", { className: classPrefix + "-mt-4n" }, extra))),
                React.createElement("div", { className: classPrefix + "-blank-page-v2__picture", style: { backgroundImage: "url(" + image.background + ")" } })),
            bottom && (React.createElement("div", { className: classPrefix + "-blank-page-v2__relative" },
                React.createElement("div", { className: classPrefix + "-blank-page-v2__relative-inner" }, bottom.map(function (item, index) { return (React.createElement("p", { key: index, className: classPrefix + "-blank-page-v2__relative-item" }, item)); }))))));
    }
    warn("当前 Blank 组件包含将废弃的属性，请尽快升级至最新用法");
    var themeImage = getCustomTheme(theme).image;
    return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-blank-page", {
            "default-error": theme === "error",
            "default-open": theme === "open",
            "default-arrears": theme === "arrears",
            "default-permission": theme === "permission",
        }, className) }, props),
        React.createElement(MediaObject, { align: "middle", media: React.createElement("div", { className: classPrefix + "-blank-page__media" },
                React.createElement("span", { className: classPrefix + "-blank-page__media-bg" }, themeImage.background && (React.createElement("img", { src: themeImage.background, alt: "" }))),
                React.createElement("span", { className: classPrefix + "-blank-page__media-gif" }, themeImage.gif && React.createElement("img", { src: themeImage.gif, alt: "" }))) },
            React.createElement(H4, { className: classPrefix + "-mb-2n" }, description),
            children,
            (operation || extra) && (React.createElement("div", { className: classPrefix + "-blank-page__op" },
                operation,
                extra && React.createElement("div", { className: classPrefix + "-mt-4n" }, extra))))));
}, {
    Steps: BlankSteps,
});
Blank.displayName = "Blank";
function getCustomTheme(theme) {
    if (typeof theme === "string") {
        return { image: { background: null, gif: null } };
    }
    return __assign({ image: {} }, theme);
}
//# sourceMappingURL=Blank.js.map